module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-wrapper"
  }, [_c('nav', {
    staticClass: "om-top-nav flex sb"
  }, [_c('div', {
    staticClass: "om-nav-logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png",
      "alt": _vm.$tr('Omniway', 'Admin')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "om-nav-right"
  }, [(_vm.isDispatch) ? _c('router-link', {
    staticClass: "om-nav-right__button",
    attrs: {
      "tag": "button",
      "to": {
        name: 'ShopSettings',
        params: {
          code: 'new'
        }
      }
    }
  }, [_c('span', {
    staticClass: "om-icon-plus"
  }, [_vm._v("+")]), _vm._v("\n        " + _vm._s(_vm.$tr('dodaj nowy sklep', 'Admin')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "om-logout-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.isDispatch ? _vm.$tr('Wyloguj', 'Admin') : (_vm.loggedShop !== null ? _vm.loggedShop.name : _vm.$tr('Wyloguj', 'Admin'))) + "\n        "), _c('img', {
    attrs: {
      "src": "/static/img/logout.png",
      "alt": _vm.$tr('Wyloguj', 'Admin')
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "om-center"
  }, [(_vm.settings && _vm.settings.logo_url) ? _c('img', {
    staticClass: "om-admin-big-logo",
    attrs: {
      "src": _vm.settings.logo_url,
      "alt": _vm.$tr('Omniway', 'Admin')
    }
  }) : _c('img', {
    staticClass: "om-admin-big-logo",
    attrs: {
      "src": "/static/temp/logo-patrizia-aryton.png",
      "alt": _vm.$tr('Omniway', 'Admin')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "om-layout flex sb clearfix",
    class: [(_vm.isDispatch ? 'om-layout--is-left-column' : '')]
  }, [(_vm.isDispatch) ? _c('aside', {
    staticClass: "om-aside"
  }, [(_vm.isDispatch) ? _c('router-link', {
    staticClass: "om-aside__link",
    attrs: {
      "activeClass": "active",
      "to": "/admin/return-list"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$tr('Lista zwrotów', 'Admin')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isDispatch) ? _c('router-link', {
    staticClass: "om-aside__link",
    attrs: {
      "activeClass": "active",
      "to": "/admin/collect-list"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$tr('Lista odbiorów', 'Admin')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isDispatch) ? _c('router-link', {
    staticClass: "om-aside__link",
    attrs: {
      "activeClass": "active",
      "to": "/admin/shop-list"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$tr('Lista sklepów', 'Admin')) + "\n      ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "om-admin-content"
  }, [_c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('keep-alive', {
    attrs: {
      "include": ['order-list']
    }
  }, [_c('router-view')], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90960cf0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin.vue
// module id = 282
// module chunks = 1